<mat-toolbar class="subtitulo">Avaliação do Beneficiário</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-form-field fxFlex="60%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione uma Atividade</mat-label>
                    <mat-select fxFlexOffset="20px" 
                                [(ngModel)]="filtroBusca.atividade" 
                                name="atividade" 
                                required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of atividades" [value]="d">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="atividades?.length === 0" align="start">Nenhuma atividade cadastrada</mat-hint>
                </mat-form-field>


                <mat-form-field fxFlex="40%"  fxFlexOffset="20px" style="margin: 0 20px 20px 20px">
                    <mat-label>Avaliações</mat-label>
                    <mat-select [(ngModel)]="filtroBusca.avaliacao" 
                                name="avaliacao" 
                                required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of avaliacoes" [value]="i">
                            {{i.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="avaliacoes?.length === 0" align="start">Nenhuma avaliação cadastrada</mat-hint>
                </mat-form-field>                
            </div>

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>
                <button mat-raised-button fxFlex="10%" (click)="consultar()" *ngIf="isFiltroPreenchido()">
                    CONSULTAR
                </button>
                <button mat-raised-button fxFlex="10%" style="padding-right: 20px" (click)="limpar()">
                    LIMPAR
                </button>
            </div>

            <div *ngIf="filtroBusca.atividade.id">
                <dados-atividade [atividade]="filtroBusca.atividade"></dados-atividade>
            </div>

            <div *ngIf="filtroBusca.avaliacao?.id">
                <dados-avaliacao [avaliacao]=filtroBusca.avaliacao></dados-avaliacao>
            </div>


            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <div fxFlex="80%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill *ngIf="mostrarTabela" >
                        <mat-form-field fxFlexOffset="20px" style="width: 100%" >
                            <mat-icon matPrefix>search</mat-icon>
                            <mat-label fxFlexOffset="20px">Informe um valor para filtrar</mat-label>
                            <input fxFlexOffset="20px" matInput (keyup)="applyFilter($event.target.value)" >
                        </mat-form-field>
                    </div>
                </div>

                <div fxFlex="20%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill 
                         *ngIf="mostrarBotaoGerarLista && isFiltroPreenchido()" class="botoes">
                        <button mat-raised-button (click)="gerarListaAvaliacoes()">
                            GERAR LISTA DE AVALIAÇÃO
                        </button>
                    </div>
                </div>

            </div>
    
            <table [fxHide]="!mostrarTabela"
                   matSort
                   mat-table
                   [dataSource]="dataSource"
                   style="margin-top: 10px">

                <ng-container matColumnDef="aluno">
                    <th mat-header-cell *matHeaderCellDef> Beneficiário </th>
                    <td mat-cell *matCellDef="let element;  let i = index" style="width: 280px">
                        {{element.atividadesAluno.aluno?.pessoaFisica?.nome}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="matriculaAluno">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Matrícula </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.atividadesAluno.aluno.matriculaAluno}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="dataavaliacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Data da avaliação </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.dataAvaliacao | dataSimples}}
                     </td>
                </ng-container>


                <ng-container matColumnDef="avaliacao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Avaliação </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        {{element.avaliacoes.nome}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nota">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nota avaliação </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <mat-form-field>
                            <mat-select [(ngModel)]="element.notaAvaliacao" 
                                        name="notaAvaliacao_{{i}}"
                                        [disabled]="element.desabilitado"
                                        required>
                                <mat-option></mat-option>
                                <mat-option *ngFor="let i of notasAvaliacao" [value]="i.id">
                                    {{i.nota}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>                            
                    </td>
                </ng-container>
    

                <ng-container matColumnDef="descricao" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                    <td mat-cell *matCellDef="let element; let i = index" style="width: 250px">
                        <span [fxHide]="!element.desabilitado" style="width: 95%">
                            {{element.descriaoAvaliacao}}    
                        </span>
                        <mat-form-field style="width: 95%" [fxHide]="element.desabilitado">
                            <input matInput
                                   maxlength="45"
                                   [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="element.descriaoAvaliacao">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element;">
                        <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="editar(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </form>

        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[10, 20, 40, 80]" showFirstLastButtons></mat-paginator>
        </div>

        <div [hidden]="mostrarTabela">
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </div>
    </div>

    <!-- BOTOES -->
    <div *ngIf="mostrarTabela" dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

        <button *ngIf="perfilAcesso.altera" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formulario.invalid" (click)="atualizar()">
            SALVAR
        </button>

    </div>

</div>
